import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { image } from 'html2canvas/dist/types/css/types/image';
import { actions } from 'react-table';
import { Password } from '@mui/icons-material';
import { types } from 'util';
import { count } from 'console';
import { descriptors } from 'chart.js/dist/core/core.defaults';
import { url } from 'inspector';
import { ca, id } from 'date-fns/locale';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import ConfigurationsPage from 'pages/ConfigurationsPage';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    interpolation: { escapeValue: false },
    resources: {
      pt: {
        translation: {
          common: {
            devices: 'DISPOSITIVOS',
            device: 'Dispositivo',
            events: 'EVENTOS',
            client: 'Cliente',
            students: 'Alunos',
            parents: 'Pais',
            IVS: 'IVS',
            LPR: 'LPR',
            description: 'Descrição',
            date: 'Data',
            plate: 'Placa',
            name: 'Nome',
            lastEvent: 'Último evento',
            image: 'Imagem',
            speed: 'Velocidade',
            plateImage: 'Imagem da Placa',
            carImage: 'Imagem do Carro',
            student: 'Estudante',
            responsible: 'Responsável',
            face: 'Face',
            recording: 'Gravação',
            gender: 'Gênero',
            recognitionImage: 'Imagem Reconhecida',
            actions: 'Ações',
            noItemsFound: 'Nenhum item encontrado',
            model: 'Modelo',
            brand: 'Marca',
            type: 'Tipo',
            active: 'Ativo',
            refresh: 'Atualizar',
            edit: 'Editar',
            delete: 'Excluir',
            unknown: 'Desconhecido',
            none: 'Não possui',
            notApplicable: 'Não se aplica',
            notAvailable: 'Não Possui',
            errorSaving: 'Erro ao salvar',
            errorLoadingData: 'Erro ao carregar dados',
          },
          monitoringPage: {
            selectDevice: 'Selecionar dispositivo',
            status: 'Status',
            online: 'Online',
            offline: 'Offline',
            loadingDevices: 'Carregando dispositivos...',
            selectDeviceHint:
              'Selecione um dispositivo para visualizar o vídeo.',
            selected: 'Selecionados',
            deviceOffline: 'Dispositivo offline',
          },
          deviceGroupPage: {
            title: 'Grupos de dispositivos',
            hint: 'Crie grupos para organizar dispositivos.',
            empty: 'Nenhum grupo cadastrado.',
            new: 'Novo grupo',
            devices: 'Dispositivos do grupo',
            devicesInGroup: 'Dispositivos no grupo',
            editGroupTitle: 'Editar grupo de dispositivos',
            newGroupTitle: 'Novo grupo de dispositivos',
            groupName: 'Nome do grupo',
            save: 'Salvar',
            confirmDelete: 'Deseja realmente excluir este grupo?',
            lock: 'Bloquear',
            unlock: 'Desbloquear',
            locked: 'Bloqueado',
            unlocked: 'Desbloqueado',
            open: 'Abrir',

          },
          dashboard: {
            welcome: 'Bem-vindo ao AlertAi',
            description:
              'Aqui você encontrará os principais indicadores da plataforma em tempo real. Navegue pelos gráficos e relatórios para acompanhar o desempenho e os eventos registrados.',
            title: 'Dashboard',
            list: 'Lista',
            defense: 'Defense',
            monitoring: 'Monitoramento',
            settings: 'Configurações',
            accountSummary: 'Resumo da conta',
            registeredDevices: 'Dispositivos cadastrados',
            activeDevices: 'Dispositivos ativos',
            faces: 'Faces gerais',
            registeredEvents: 'Eventos registrados',
            notifications: 'Notificações',
          },
          map: {
            locations: 'Localizações',
            showAll: "Mostrar todos",
            showSelected: "Mostrar apenas selecionado",
            openList: "Abrir lista de localizações",
            closeList: "Fechar lista de localizações",
            stopFollow: "Parar de seguir",
            vehicle: 'Veículo',
            latitude: 'Latitude',
            longitude: 'Longitude',
            date: 'Data/Hora',
          },
          monitoring: {
            Facial: 'Facial',
            Responsible: 'Responsável',
            Student: 'Aluno',
            dontHaveEvents: 'Não há nenhum evento.',
            eventsIVS: 'Eventos IVS',
            eventsLPR: 'Eventos LPR',
            eventsFacial: 'Eventos Faciais',
          },
          schoolMonitoring: {
            recording: 'Gravação',
            noResponsiblesAttached: 'Não há responsáveis atrelados a este aluno',
            noStudentsAttached: 'Não há alunos pertencentes a este responsável',
            videoNotFound: 'URL do vídeo não encontrada.',
            errorDownloading: 'Erro ao processar a solicitação do vídeo.',
            errorPlayingVideo: 'Não foi possível reproduzir este vídeo.',
          },
          pauseButtonComponent: {
            startUpdates: 'Iniciar Atualizações',
            pauseUpdates: 'Pausar Atualizações',
          },
          customerMonitoring: {
            birthday: 'Aniversário',
          },
          actionsOptions: {
            configuration: 'Configuração',
            viewEvents: 'Ver Eventos',
            viewRecording: 'Ver Video',
            edit: 'Editar',
            delete: 'Excluir',
          },
          actionButtonComponent: {
            edit: 'Editar',
            delete: 'Excluir',
          },
          tableComponent: {
            searchHere: 'Pesquisar aqui',
            search: 'Pesquisar',
          },
          camsPage: {
            title: 'Câmeras',
            addCam: 'Nova Câmera',
            manageGroups: 'Gerenciar Grupos',
          },
          controllersPage: {
            title: 'Controladores',
            addController: 'Novo Controlador',
          },
          routersNames: {
            dashboard: 'Dashboard',
            proposalPdf: 'Proposta PDF',
            serversPage: 'Servidores',
            monitoring: 'Monitoramento',
            geral: 'Geral',
            porter: 'Portaria',
            schoolMonitoring: 'Monitoramento Escolar',
            perimeterSchool: 'Perímetro Escolar',
            customerMonitoring: 'Clientes',
            devices: 'Dispositivos',
            cams: 'Câmeras',
            controllers: 'Controladores',
            centralAlarms: 'Centrais de Alarme',
            registerFaces: 'Faces',
            sports: 'Esportes',
            integrationsPage: 'Integrações',
            configuration: 'Configuração',
            communicationPage: 'Comunicação',
            remoteTax: 'Inspetor Remoto',
            report: 'Relatórios',
            trans: 'Transporte',
            turn: 'Turno Escolar',
            ticket: 'Ticket Escolar',
            defense: 'DefenseIA',
            management: 'Gestão',
            class: 'Turmas',
            logout: 'Sair',
          },
          alarmCentral: {
            physical: 'Física',
            virtual: 'Virtual',
            editionTitle: 'Edição da central',
            type: 'Tipo de Central',
            macAddress: 'Endereço MAC',
            password: 'Senha',
            account: 'Conta',
            partitionable: 'Central Particionada',
            event: 'Evento',
            zoneUser: 'Zona/Usuário',
            partition: 'Partição',
            occurredAt: 'Aconteceu em',
            newCentral: 'Nova central',
            title: 'Centrais de alarme',
            tabCentrals: 'Centrais',
            tabEvents: 'Eventos',
            deleteTitle: 'Excluir central de alarme',
            deleteMessage:
              'Tem certeza que deseja excluir a central de alarme "{{name}}"?',
          },
          recognitionPage: {
            title: 'Faces',
            cleanFilters: 'Limpar Filtros',
            synchronization: 'Sincronização',
            newFace: 'Nova Face',
            deleteFace: 'Deletar Face',
            areYouSureWantToDeleteFace:
              'Tem certeza que deseja excluir esta face?',
            recognitionImage: 'Imagem da face',
            tableHeaders: {
              type: 'Tipo',
              name: 'Nome',
              CPF: 'CPF',
              CNPJ: 'CNPJ',
              image: 'Imagem',
              actions: 'Ações',
            },
            registerFace: {
              general: 'Geral',
              student: 'Estudante',
              responsible: 'Responsável',
              customer: 'Cliente',
              youForgotToTakeAPicture:
                'Oops! Parece que você esqueceu de registrar a imagem da face.',
              updatedFace: 'Face atualizada com sucesso!',
              registerFace: 'Face cadastrada com sucesso!',
              updatingFace: 'Face sendo atualizada...',
              registeringFace: 'Face sendo cadastrada...',
            },
            modalEditFace: {
              title: 'Edição de Face',
              name: 'Nome',
              cpf: 'CPF',
              cnpj: 'CNPJ',
              email: 'Email',
              password: 'Senha',
              faceValidity: 'Validade da Face',
              type: 'Tipo',
              employee: 'Funcionário',
              occupation: 'Ocupação',
              birthdayDate: 'Data de Nascimento',
              identification: 'Identificação',
              filterCondition: 'Condição',
              genders: {
                gender: 'Gênero',
                male: 'Masculino',
                female: 'Feminino',
                other: 'Outro',
              },
              age: 'Idade',
              editFace: 'Editar Face',
              registerFace: 'Registrar Face',
              serviceProvider: 'Prestador de Serviço',
              visitor: 'Visitante',
              faceGroup: 'Grupo de Faces',
              deviceGroup: "Grupo de dispositivos",
              facialController: 'Controlador Facial',
              shift: 'Turno',
              class: 'Turma',
              corporateUnity: 'UC (Unidade Corporativa)',
              cellPhone: 'Telefone Celular',
              addAddress: 'Adicionar endereço (opcional)',
              registration: 'Matrícula',
              dateOfBirth: 'Data de Nascimento',
              responsible: 'Responsável',
              cantLeave: 'Não pode sair?',
              schoolTransport: 'Transporte Escolar',
              editPassword: 'Editar senha',
              repeatPassword: 'Repetir senha',
              temporaryStudents: 'Alunos Temporários',
              recognitionFilter: 'Filtro de Reconhecimento',
              filter: 'Filtrar',
              filterAll: 'Todos',
              filterTemporary: 'Temporário',
              plateVehicle: 'Placa do Veículo',
              vehicleTags: 'Tag do Veículo',
              accessCardTags: 'Cartão/Tag de Acesso',
              status: 'Status',
              filterActive: 'Ativos',
              filterDisabled: 'Desativados',
              address: {
                address: 'Endereço',
                postalCode: 'Código Postal',
                country: 'País',
                state: 'Estado',
                city: 'Cidade',
                neighborhood: 'Bairro',
                street: 'Rua',
                addrNumber: 'Número',
                complement: 'Complemento',
              },
              buttonCaptureImage: {
                captureAgain: 'Capturar Novamente',
                save: 'Salvar',
                captureImageFace: 'Capturar Imagem da Face',
                changeFaceImage: 'Modificar Imagem da Face',
              },
              typesOfResponsible: {
                faceType: 'Tipo de Face',
                general: 'Geral',
                student: 'Estudante',
                responsible: 'Responsável',
                customer: 'Cliente',
                faceTypeNotFound: 'Tipo de face não encontrado',
                unsupportedFaceType: 'Tipo de face não suportado',
              },
            },
            syncFacesModal: {
              title: 'Sincronização de Faces',
              registeredInAlertAI: 'Registrado no AlertAI',
              noRegisteredInAlertAI: 'Não registrado no AlertAI',
              deleteController: 'Excluir controlador',
              fillInMissingData: 'Preencher dados faltantes',
              noRegisterFaces: 'Nenhuma face cadastrada no controlador.',
              facesFoundOnController: 'Faces encontradas no controlador',
            },
          },
          sportsPage: {
            sportsFacilities: 'Unidades Esportivas',
            sportsCourts: 'Quadras Esportivas',
            newUnity: 'Nova Unidade',
            unities: {
              name: 'Nome',
              state: 'Estado',
              city: 'Cidade',
              actions: 'Ações',
              sportUnityModal: {
                addTitle: 'Adicionar Unidade Esportiva',
                editTitle: 'Editar Unidade Esportiva',
                name: 'Nome',
                address: 'Endereço',
                state: 'Estado',
                city: 'Cidade',
                country: 'País',
                postalCode: 'Código Postal',
                neighborhood: 'Bairro',
                street: 'Rua',
                number: 'Número',
                complement: 'Complemento',
                saveButton: 'Salvar',
              },
            },
            blocks: {
              title: 'Blocos Esportivos',
              newBlock: 'Nova Quadra',
              name: 'Nome',
              unity: 'Unidade',
              actions: 'Ações',
              sportBlockModal: {
                addTitle: 'Adicionar Bloco Esportivo',
                editTitle: 'Editar Bloco Esportivo',
                name: 'Nome',
                unitySports: 'Unidade Esportiva',
                saveButton: 'Salvar',
                devices: 'Dispositivos',
                playbackTime: 'Tempo de Reprodução',
                playbackTimeOptions: {
                  option1: '20 segundos',
                  option2: '30 segundos',
                  option3: '40 segundos',
                },
                advertising: 'Publicidade',
              },
              sportsCourtSuccessUpdate:
                'Quadra Esportiva atualizada com sucesso!',
              sportsCourtSuccessCreate: 'Quadra Esportiva criada com sucesso!',
              imagemUploaderComponent: {
                dropImageHereOrClickToUpload:
                  'Solte a imagem aqui ou clique para enviar',
                requiredField: 'Campo obrigatório',
                invalidImageDimensions: 'Dimensões de imagem inválidas',
              },
            },
          },
          integrationsPage: {
            title: 'Integrações',
            newIntegration: 'Nova Integração',
            editIntegration: 'Editar Integração',
            typeIntegration: 'Tipo de Integração',
            tableColumns: {
              type: 'Tipo',
              name: 'Nome',
              description: 'Descrição',
              actions: 'Ações',
            },
            cigamForms: {
              name: 'Nome',
              host: 'Host',
              door: 'Porta',
              user: 'Usuário',
              password: 'Senha',
              descriptors: 'Descrição',
              active: 'Ativo',
            },
            defenseForms: {
              name: 'Nome',
              username: 'Nome de Usuário',
              ipServer: 'Ip do Servidor',
              mqttDoorServer: 'Porta MQTT do Servidor',
              userType: 'Tipo de Usuário',
              password: 'Senha',
              httpDoorServer: 'Ports HTTP do Servidor',
              description: 'Descrição',
              status: 'Status',
              save: 'Salvar',
            },
            moniForms: {
              name: 'Nome',
              door: 'Porta',
              password: 'Senha',
              enterprise: 'Empresa',
              ip: 'IP',
              user: 'Usuário',
              jointOccurrenceCode: 'Código conjunto de ocorrências',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            sigmaForms: {
              name: 'Nome',
              accountsReceivableEvents: 'Eventos de Contas a Receber',
              token: 'Token',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            surgardForms: {
              typeConnection: 'Tipo de Conexão',
              door: 'Porta',
              description: 'Descrição',
              name: 'Nome',
              intervalKeepAlive: 'Intervalo Keep Alive (Em segundos)',
              waitACK: 'Aguardar ACK',
              active: 'Ativo',
              save: 'Salvar',
            },
            webHookForms: {
              name: 'Nome',
              url: 'URL',
              token: 'Token',
              password: 'Senha',
              description: 'Descrição',
              user: 'Usuário',
              bodyRequisition: 'Corpo da Requisição',
              active: 'Ativo',
              save: 'Salvar',
            },
            defenseBridgeForms: {
              name: 'Nome',
              ipServer: 'IP do Servidor',
              doorServer: 'Porta do Servidor',
              description: 'Descrição',
              accessKey: 'Chave de Acesso',
              secretKey: 'Chave Secreta',
              status: 'Status',
              save: 'Salvar',
            },
            totvsForms: {
              name: 'Nome',
              domain: 'Domínio',
              user: 'Usuário',
              password: 'Senha',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            tuyaForms: {
              name: 'Nome',
              descriptors: 'Descrição',
              idUserTuya: 'ID de Usuário Tuya',
              status: 'Status',
              save: 'Salvar',
            },
            smtpForms: {
              host: 'Host',
              port: 'Porta',
              enableSsl: 'Habilitar SSL',
              username: 'Nome de Usuário',
              password: 'Senha',
              description: 'Descrição',
              isActive: 'Ativo',
              fromAddress: 'E-mail do Remetente',
              save: 'Salvar',
              name: 'Nome',
            }
          },
          defensePage: {
            deviceTable: {
              title: 'Dispositivos DefenseIA',
              synchronize: 'Sincronizar',
              columnTables: {
                status: 'Status',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                defenseID: 'ID Defense',
                actions: 'Ações',
              },
              detailsDefenseDeviceModal: {
                title: 'Detalhes do Dispositivo',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                category: 'Categoria',
                status: 'Status',
                idDefense: 'ID Defense',
                type: 'Tipo',
                ip: 'IP',
                protocol: 'Protocolo',
              },
            },
          },
          configurationPage: {
            users: {
              title: 'Usuário cadastrados',
              newUser: 'Novo usuário',
              name: 'Nome',
              email: 'Email',
              positions: 'Cargos',
              action: 'Ações',
            },
          },
        },
      },
      es: {
        translation: {
          common: {
            devices: 'DISPOSITIVOS',
            device: 'Dispositivo',
            events: 'EVENTOS',
            client: 'Cliente',
            students: 'Estudiantes',
            parents: 'Padres',
            IVS: 'IVS',
            LPR: 'LPR',
            description: 'Descripción',
            date: 'Fecha',
            plate: 'Placa',
            name: 'Nombre',
            lastEvent: 'Último evento',
            image: 'Imagen',
            speed: 'Velocidad',
            plateImage: 'Imagen de la Placa',
            carImage: 'Imagen del Auto',
            student: 'Estudiante',
            responsible: 'Responsable',
            face: 'Rostro',
            recording: 'Grabación',
            gender: 'Género',
            recognitionImage: 'Imagen Reconocida',
            actions: 'Acciones',
            noItemsFound: 'No se encontraron elementos',
            model: 'Modelo',
            brand: 'Marca',
            type: 'Tipo',
            active: 'Ativo',
            edit: 'Editar',
            delete: 'Eliminar',
            unknown: 'Desconocido',
            none: 'No tiene',
            notApplicable: 'No aplica',
            notAvailable: 'No Posee',
            errorSaving: 'Error al guardar',
            errorLoadingData: 'Error al cargar datos',
          },
          dashboard: {
            welcome: 'Bienvenido a AlertAi',
            description:
              'Aquí encontrarás los principales indicadores de la plataforma en tiempo real. Navega por los gráficos e informes para seguir el rendimiento y los eventos registrados.',
            title: 'Dashboard',
            list: 'Lista',
            defense: 'Defense',
            monitoring: 'Monitoreo',
            settings: 'Configuraciones',
            accountSummary: 'Resumen de la cuenta',
            registeredDevices: 'Dispositivos registrados',
            activeDevices: 'Dispositivos ativos',
            faces: 'Rostros gerais',
            registeredEvents: 'Eventos registrados',
            notifications: 'Notificaciones',
          },
          map: {
            locations: 'Ubicaciones',
            showAll: "Mostrar todos",
            showSelected: "Mostrar solo seleccionado",
            openList: "Abrir lista de ubicaciones",
            closeList: "Cerrar lista de ubicaciones",
            stopFollow: "Dejar de seguir",
            vehicle: 'Vehículo',
            latitude: 'Latitud',
            longitude: 'Longitud',
            date: 'Fecha/Hora',
          },
          monitoring: {
            Facial: 'Facial',
            Responsible: 'Responsable',
            Student: 'Estudiante',
            dontHaveEvents: 'No hay ningún evento.',
            eventsIVS: 'Eventos IVS',
            eventsLPR: 'Eventos LPR',
            eventsFacial: 'Eventos Faciales',
          },
          monitoringPage: {
            selectDevice: 'Seleccionar dispositivo',
            status: 'Estado',
            online: 'En línea',
            offline: 'Sin conexión',
            loadingDevices: 'Cargando dispositivos...',
            selectDeviceHint: 'Seleccione un dispositivo para ver el video.',
            selected: 'Seleccionados',
            deviceOffline: 'Dispositivo sin conexión',
          },
          deviceGroupPage: {
            title: 'Grupos de dispositivos',
            hint: 'Cree grupos para organizar dispositivos.',
            empty: 'No hay grupos registrados.',
            new: 'Nuevo grupo',
            devices: 'Dispositivos del grupo',
            devicesInGroup: 'Dispositivos en el grupo',
            editGroupTitle: 'Editar grupo de dispositivos',
            newGroupTitle: 'Nuevo grupo de dispositivos',
            groupName: 'Nombre del grupo',
            save: 'Guardar',
            confirmDelete: '¿Desea realmente eliminar este grupo?',
            lock: 'Bloquear',
            unlock: 'Desbloquear',
            locked: 'Bloqueado',
            unlocked: 'Desbloqueado',
            refresh: 'Atualizar',
            open: 'Abrir',
          },

          schoolMonitoring: {
            recording: 'Grabación',
            noResponsiblesAttached: 'No hay responsables vinculados a este estudiante',
            noStudentsAttached: 'No hay estudiantes pertenecientes a este responsable',
            videoNotFound: 'URL del vídeo no encontrada.',
            errorDownloading: 'Error al procesar la solicitud del vídeo.',
            errorPlayingVideo: 'No fue posible reproducir este vídeo.',
          },
          pauseButtonComponent: {
            startUpdates: 'Iniciar Atualizações',
            pauseUpdates: 'Pausar Atualizações',
          },
          customerMonitoring: {
            birthday: 'Cumpleaños',
          },
          actionsOptions: {
            configuration: 'Configuración',
            viewEvents: 'Ver Eventos',
            viewRecording: 'Ver Video',
            edit: 'Editar',
            delete: 'Eliminar',
          },
          actionButtonComponent: {
            edit: 'Editar',
            delete: 'Eliminar',
          },
          tableComponent: {
            searchHere: 'Buscar aquí',
            search: 'Buscar',
          },
          camsPage: {
            title: 'Cámaras',
            addCam: 'Agregar Cámara',
            manageGroups: 'Administrar Grupos',
          },
          controllersPage: {
            title: 'Controladores',
            addController: 'Nuevo Controlador',
          },
          routersNames: {
            dashboard: 'Panel de Control',
            proposalPdf: 'Propuesta PDF',
            serversPage: 'Servidores',
            monitoring: 'Monitoreo',
            geral: 'General',
            porter: 'Portaria',
            schoolMonitoring: 'Monitoreo Escolar',
            perimeterSchool: 'Perímetro Escolar',
            customerMonitoring: 'Clientes',
            devices: 'Dispositivos',
            cams: 'Cámaras',
            controllers: 'Controladores',
            centralAlarms: 'Centrales de Alarma',
            registerFaces: 'Rostros',
            sports: 'Deportes',
            integrationsPage: 'Integraciones',
            configuration: 'Configuración',
            communicationPage: 'Comunicación',
            remoteTax: 'Inspector Remoto',
            report: 'Informes',
            trans: 'Transporte',
            turn: 'Turno Escolar',
            ticket: 'Ticket Escolar',
            defense: 'DefenseIA',
            management: 'Gestión',
            class: 'Clases',
            logout: 'Salir',
          },
          alarmCentral: {
            physical: 'Física',
            virtual: 'Virtual',
            editionTitle: 'Edición de la central',
            type: 'Tipo de Central',
            macAddress: 'Dirección MAC',
            password: 'Contraseña',
            account: 'Cuenta',
            partitionable: 'Central Particionada',
            event: 'Evento',
            zoneUser: 'Zona/Usuario',
            partition: 'Partición',
            occurredAt: 'Ocurrió en',
            newCentral: 'Nueva central',
            title: 'Centrales de alarma',
            tabCentrals: 'Centrales',
            tabEvents: 'Eventos',
            deleteTitle: 'Eliminar central de alarma',
            deleteMessage:
              '¿Está seguro de que desea eliminar la central de alarma "{{name}}"?',
          },
          recognitionPage: {
            title: 'Rostros',
            cleanFilters: 'Limpiar Filtros',
            synchronization: 'Sincronización',
            newFace: 'Nuevo Rostro',
            deleteFace: 'Eliminar Rostro',
            areYouSureWantToDeleteFace:
              '¿Está seguro de que desea eliminar este rostro?',
            recognitionImage: 'Imagen de la cara',
            tableHeaders: {
              type: 'Tipo',
              name: 'Nombre',
              CPF: 'CPF',
              CNPJ: 'CNPJ',
              image: 'Imagen',
              actions: 'Acciones',
            },
            registerFace: {
              general: 'General',
              student: 'Estudiante',
              responsible: 'Responsable',
              customer: 'Cliente',
              youForgotToTakeAPicture:
                '¡Vaya! Parece que olvidaste registrar la imagen del rostro.',
              updatedFace: '¡Rostro actualizado con éxito!',
              registerFace: '¡Rostro registrado con éxito!',
              updatingFace: 'Rostro siendo actualizado...',
              registeringFace: 'Rostro siendo registrado...',
            },
            modalEditFace: {
              title: 'Edición de Rostro',
              editFace: 'Editar Rostro',
              registerFace: 'Registrar Rostro',
              name: 'Nombre',
              cpf: 'CPF',
              cnpj: 'CNPJ',
              age: 'Edad',
              email: 'Email',
              faceValidity: 'Validez del Rostro',
              type: 'Tipo',
              occupation: 'Ocupación',
              birthdayDate: 'Fecha de Nacimiento',
              employee: 'Empleado',
              genders: {
                gender: 'Género',
                male: 'Masculino',
                female: 'Femenino',
                other: 'Otro',
              },
              serviceProvider: 'Proveedor de Servicios',
              visitor: 'Visitante',
              faceGroup: 'Grupo de Rostros',
              deviceGroup: "Grupo de dispositivos",
              facialController: 'Controlador Facial',
              shift: 'Turno',
              corporateUnity: 'UC (Unidad Corporativa)',
              cellPhone: 'Teléfono Celular',
              addAddress: 'Agregar dirección (opcional)',
              registration: 'Registro',
              dateOfBirth: 'Fecha de Nacimiento',
              cantLeave: 'No puedo irme?',
              schoolTransport: 'Transporte Escolar',
              responsible: 'Responsable',
              editPassword: 'Editar contraseña',
              repeatPassword: 'Repetir contraseña',
              temporaryStudents: 'Estudiantes Temporales',
              recognitionFilter: 'Filtro de Reconocimiento',
              filter: 'Filtrar',
              filterAll: 'Todos',
              filterTemporary: 'Temporal',
              plateVehicle: 'Placa del Vehículo',
              vehicleTags: 'Tag del Vehículo',
              accessCardTags: 'Tarjeta/Tag de Acceso',
              status: 'Estado',
              filterActive: 'Activos',
              filterDesabled: undefined,
              filterDisabled: 'Desactivados',
              filterCondition: 'Condición',
              address: {
                address: 'Dirección',
                postalCode: 'Código Postal',
                country: 'País',
                state: 'Estado',
                city: 'Ciudad',
                neighborhood: 'Vecindario',
                street: 'Calle',
                addrNumber: 'Número',
                complement: 'Complementar',
              },
              buttonCaptureImage: {
                captureAgain: 'Capturar Nuevamente',
                save: 'Guardar',
                captureImageFace: 'Capturar Imagen del Rostro',
                changeFaceImage: 'Modificar Imagen del Rostro',
              },
              typesOfResponsible: {
                faceType: 'Tipo de Rostro',
                general: 'General',
                student: 'Estudiante',
                customer: 'Cliente',
                responsible: 'Responsable',
                faceTypeNotFound: 'Tipo de rostro no encontrado',
                unsupportedFaceType: 'Tipo de rostro no compatible',
              },
            },
            syncFacesModal: {
              title: 'Sincronización de Rostros',
              registeredInAlertAI: 'Registrado en AlertAI',
              noRegisteredInAlertAI: 'No registrado en AlertAI',
              deleteController: 'Eliminar controlador',
              fillInMissingData: 'Rellenar datos faltantes',
              noRegisterFaces: 'Ningún rostro registrado en el controlador.',
              facesFoundOnController: 'Caras encontradas en el controlador',
            },
          },
          sportsPage: {
            sportsFacilities: 'Unidades Deportivas',
            sportsCourts: 'Canchas Deportivas',
            newUnity: 'Nueva Unidad',
            unities: {
              name: 'Nombre',
              state: 'Estado',
              city: 'Ciudad',
              actions: 'Acciones',
              sportUnityModal: {
                addTitle: 'Agregar Unidad Deportiva',
                editTitle: 'Editar Unidad Deportiva',
                name: 'Nombre',
                address: 'Dirección',
                state: 'Estado',
                city: 'Ciudad',
                country: 'País',
                postalCode: 'Código Postal',
                neighborhood: 'Barrio',
                street: 'Calle',
                number: 'Número',
                complement: 'Complementar',
                saveButton: 'Guardar',
              },
            },
            blocks: {
              title: 'Bloques Deportivos',
              newBlock: 'Nueva Cancha',
              name: 'Nombre',
              unity: 'Unidad',
              actions: 'Acciones',
              save: 'Guardar',
              sportBlockModal: {
                addTitle: 'Agregar Cancha Deportivo',
                editTitle: 'Editar Cancha Deportivo',
                name: 'Nombre',
                unitySports: 'Unidad Deportiva',
                saveButton: 'Guardar',
                devices: 'Dispositivos',
                playbackTime: 'Tiempo de Reproducción',
                advertising: 'Publicidad',
                playbackTimeOptions: {
                  option1: '20 segundos',
                  option2: '30 segundos',
                  option3: '40 segundos',
                },
              },
              sportsCourtSuccessUpdate:
                '¡Cancha Deportiva actualizada con éxito!',
              sportsCourtSuccessCreate: '¡Cancha Deportiva creada con éxito!',
              imagemUploaderComponent: {
                dropImageHereOrClickToUpload:
                  'Suelta la imagen aquí o haz clic para subirla',
                requiredField: 'Campo obligatorio',
                invalidImageDimensions: 'Dimensiones de imagen inválidas',
              },
            },
          },
          integrationsPage: {
            title: 'Integraciones',
            newIntegration: 'Nueva Integración',
            editIntegration: 'Editar Integración',
            typeIntegration: 'Tipo de Integración',
            tableColumns: {
              type: 'Tipo',
              name: 'Nombre',
              description: 'Descripción',
              actions: 'Acciones',
            },
            cigamForms: {
              name: 'Nombre',
              host: 'Host',
              door: 'Puerto',
              user: 'Usuario',
              password: 'Contraseña',
              descriptors: 'Descripción',
              active: 'Activo',
            },
            defenseForms: {
              name: 'Nombre',
              username: 'Nombre de Usuario',
              ipServer: 'Ip del Servidor',
              mqttDoorServer: 'Puerto MQTT del Servidor',
              userType: 'Tipo de Usuario',
              password: 'Contraseña',
              httpDoorServer: 'Puerto HTTP del Servidor',
              description: 'Descripción',
              status: 'Estado',
              save: 'Guardar',
            },
            moniForms: {
              name: 'Nombre',
              door: 'Puerto',
              password: 'Contraseña',
              enterprise: 'Empresa',
              ip: 'IP',
              user: 'Usuario',
              jointOccurrenceCode: 'Código conjunto de ocurrencias',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            sigmaForms: {
              name: 'Nombre',
              accountsReceivableEvents: 'Eventos de Cuentas por Cobrar',
              token: 'Token',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            surgardForms: {
              typeConnection: 'Tipo de Conexión',
              door: 'Puerto',
              description: 'Descripción',
              name: 'Nombre',
              intervalKeepAlive: 'Intervalo Keep Alive (En segundos)',
              waitACK: 'Esperar ACK',
              active: 'Activo',
              save: 'Guardar',
            },
            webHookForms: {
              name: 'Nombre',
              url: 'URL',
              token: 'Token',
              password: 'Contraseña',
              description: 'Descripción',
              user: 'Usuario',
              bodyRequisition: 'Cuerpo de la Requisición',
              active: 'Activo',
              save: 'Guardar',
            },
            defenseBridgeForms: {
              name: 'Nombre',
              ipServer: 'IP del Servidor',
              doorServer: 'Puerto del Servidor',
              description: 'Descripción',
              accessKey: 'Clave de Acceso',
              secretKey: 'Clave Secreta',
              status: 'Estado',
              save: 'Guardar',
            },
            totvsForms: {
              name: 'Nombre',
              domain: 'Dominio',
              user: 'Usuario',
              password: 'Contraseña',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            tuyaForms: {
              name: 'Nombre',
              description: 'Descripción',
              idUserTuya: 'ID de Usuario Tuya',
              status: 'Estado',
              save: 'Guardar',
            },
            smtpForms: {
              host: 'Host',
              port: 'Puerto',
              enableSsl: 'Habilitar SSL',
              username: 'Nombre de Usuario',
              password: 'Contraseña',
              description: 'Descripción',
              isActive: 'Activo',
              fromAddress: 'Correo electrónico del Remitente',
              save: 'Guardar',
              name: 'Nombre',
            },
          },
          defensePage: {
            deviceTable: {
              title: 'Dispositivos DefenseIA',
              synchronize: 'Sincronizar',
              columnTables: {
                status: 'Status',
                name: 'Nombre',
                model: 'Modelo',
                brand: 'Marca',
                defenseID: 'ID Defense',
                actions: 'Acciones',
              },
              detailsDefenseDeviceModal: {
                title: 'Detalhes do Dispositivo',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                category: 'Categoria',
                status: 'Status',
                idDefense: 'ID Defense',
                type: 'Tipo',
                ip: 'IP',
                protocol: 'Protocolo',
              },
            },
          },
          configurationPage: {
            users: {
              title: 'Usuarios registrados',
              newUser: 'Nuevo usuario',
              name: 'Nombre',
              email: 'Correo electrónico',
              positions: 'Cargos',
              action: 'Acciones',
            },
          },
        },
      },
    },
  });

export default i18n;
